import { Checkbox, styled } from '@mui/material';

export const CheckboxStyled = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  color: theme.palette.colors.mainFocused,
  '&.Mui-checked': {
    color: theme.palette.colors.highlight,
  },
}));
